import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 104px;
  padding: 9px 20px;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
  background-color: ${props => props.theme.colors.secondary};
  transition: ${props => props.theme.transition.main};

  &:hover {
    background-color: ${props => props.theme.colors.hoverColor};
    color: ${props => props.theme.brand.ink};
  }

  @media screen and (max-width: 1279px) {
    font-size: 13px;
    min-width: auto;
    padding: 8px 16px;
  }
`;
